export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0019s_0000_Black-&-White-32.71372faa.png";